import { sortMembersByType, teamsClient } from '@atlaskit/teams-client';
import type { TeamMembership, User } from '@atlaskit/teams-client/types';

import type { StoreApi } from '../types';

export const approveJoinRequest =
	(teamId: string, memberId: string, user: User) =>
	async ({ getState, setState }: StoreApi): Promise<void> => {
		const membership = await teamsClient.acceptJoinRequest(teamId, memberId);

		const state = getState();

		const {
			myTeamMembership,
			teamMembers,
			teamProfile: { teamId: currentTeamId },
		} = state;

		if (currentTeamId !== teamId || membership.state !== 'FULL_MEMBER') {
			return;
		}

		const newMembership: Required<TeamMembership> = {
			...membership,
			user,
		};

		const newMembers = teamMembers.members
			.filter((membership) => {
				return membership.membershipId.memberId !== memberId;
			})
			.concat(newMembership);

		const myMembership = myTeamMembership.membership;

		setState({
			...state,
			teamMembers: {
				teamId,
				hasLoaded: true,
				isLoadingNextPage: false,
				hasError: false,
				isLoading: false,
				errorType: null,
				membersPageInfo: teamMembers.membersPageInfo,
				requestingToJoinUsersPageInfo: teamMembers.requestingToJoinUsersPageInfo,
				members: sortMembersByType(newMembers, myMembership?.membershipId.memberId),
				requestingToJoinUsers: teamMembers.requestingToJoinUsers.filter(
					(user) => user.membershipId.memberId !== memberId,
				),
			},
		});
	};
